// import bulgarian from "./messages/bg";
import english from "./messages/en";
// import japan from "./messages/ja";

export const messages = {
  en: english,
  // ja: japan,
  // bg: bulgarian,
};
